// ───────────────────────────────────────────────────────────────────────────
// Shared partner favicon resolution.
//
// Single source of truth for the slug -> domain map, imported by both
// SharePageModal and SharePageSection (and anywhere else a partner icon is
// shown). Keep the map here ONLY — don't duplicate it per component.
//
//   • Use `domain`  -> favicon is pulled from that site via Google's service.
//   • Use `iconUrl` -> use this exact hosted icon instead (for partners whose
//                      real favicon is low quality / a generic globe).
//   • Slug not in the map -> getPartnerFaviconUrl() returns null and the
//                            consumer falls back to the partner logo.
// ───────────────────────────────────────────────────────────────────────────
export const PARTNER_ICONS = {
    explorandes: { domain: 'explorandes.com' },
    'amazonas-explorer': { domain: 'amazonas-explorer.com' },
    'rainforest-expeditions-sac': { domain: 'rainforestexpeditions.com' },
    'andean-lodges': { domain: 'andeanlodges.com' },
    'camino-del-apu-ausangate-scrl': { domain: 'andeanlodges.com' },
    'condor-travel': { domain: 'condortravel.com' },
    'condor-travel-sa': { domain: 'condortravel.com' },
    'condor-travel-s-a-c': { domain: 'condortravel.com' },
    'domiruth-travel-service-s-a-c-46': { domain: 'domiruthperutravel.com' },
    trexperience: { domain: 'trexperienceperu.com' },
    trexperienceperu: { domain: 'trexperienceperu.com' },
    'peru-for-less': { domain: 'peruforless.com' },
    'action-peru-treks': { domain: 'actionperutreks.com' },
    'action-peru-treks-21': { domain: 'actionperutreks.com' },
    'crees-manu-s-a-c': { domain: 'crees-manu.org' },
    'magri-tour-operator-ltda': { domain: 'magritouroperator.com' },
    'sa-luxury-expeditions-llc': { domain: 'saexpeditions.com' },
    'expertia-travel-s-a': { domain: 'expertiatravel.com' },
    'nature-services-peru': { domain: 'regenera.earth' },
    'responsible-travel-peru': { domain: 'responsibletravel.com' },
    'tropic-travel': { domain: 'tropiceco.com' },
    'qhapac-nan-travel-sac': { domain: 'www.qnperu.com' },
    'qn-travel-peru': { domain: 'www.qnperu.com' },
    'candor-joyer-a': { domain: 'www.candor.pe' },
    'rivers-forest-expeditions': { domain: 'rfexpeditions.com' },
    'albergue-ollantaytambo-e-i-r-l': { domain: 'https://elalbergue.com' },
    'caritas-abancay': { domain: 'caritasabancay.org' },
    // 'asociaci-n-servicios-ecosist-micos-per-seperu': { domain: '' },    // SEPERU association
    'hotelera-del-valle-s-a-c': { domain: 'antiguacusco.com' },
    'hotelera-del-valle-sac': { domain: 'antiguacusco.com' },
    'trigono-capital': { domain: 'trigonocapital.com' },
    'doble-e-inversiones-s-a-c': { domain: 'www.ee-co.com' },
    // 'sociedad-inmobiliaria-los-algarrobos-sa': { domain: '' },          // real estate — likely no usable favicon
    'strategik-sac': { domain: 'sacstrategic.com' },
    'elementa-srl': { domain: 'elementa.srl' },
    // 'independiente':                  individual — always logo fallback
};

// Requested favicon resolution. 128 leaves room for crisp display.
export const FAVICON_PX = 128;

export const getPartnerFaviconUrl = (slug, website) => {
    const entry = (slug && PARTNER_ICONS[slug]) || (website ? { domain: website } : null);
    if (!entry) return null;
    if (entry.iconUrl) return entry.iconUrl;
    if (!entry.domain) return null;
    const domain = entry.domain.replace(/^https?:\/\//, '').replace(/\/.*$/, '');
    return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(
        domain
    )}&sz=${FAVICON_PX}`;
};
